import { render } from "./Accounting.vue?vue&type=template&id=4585f5e9&scoped=true"
import script from "./Accounting.vue?vue&type=script&lang=js"
export * from "./Accounting.vue?vue&type=script&lang=js"

import "./Accounting.vue?vue&type=style&index=0&id=4585f5e9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4585f5e9"

export default script